import $fetch from '@/services/client'
import type { SendEmailBody } from '@/services/schemas'

async function sendEmail(body: SendEmailBody) {
  const response = await $fetch('mycontroller/send-configuration/json', {
    body,
  })

  return response
}

export default sendEmail
